import { Box, Button, Typography } from '@mui/material';
import React, { useState } from 'react';
import BillingHistory from './BillingHistory';
import AddCardDetailsModal from './AddCardDetailsModal'; // 👈 modal import
import CardPreviewModal from './CardPreviewModal';

const BillingInformation = () => {
  // const [openAddCard, setOpenAddCard] = useState(false);
  const [openForm, setOpenForm] = useState(false);
  const [openPreview, setOpenPreview] = useState(false);
  const [cards, setCards] = useState([]);

  const handleSaveCard = (card) => {
    setCards((prev) => [...prev, card]);
    setOpenPreview(true);
  };
  return (
    <>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        {/* Your Plan Section */}
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Box>
            <Typography sx={{ fontSize: '16px', fontWeight: '600', color: '#1A1F36', fontFamily: 'Manrope' }}>Your plan</Typography>
            <Typography variant="span" sx={{ fontSize: '14px', fontWeight: '400', color: '#606060', fontFamily: 'Manrope' }}>Status</Typography>
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'end', alignItems: 'center', gap: 1 }}>
            <Button sx={{ background: '#F3F4F6', borderRadius: '50px', color: '#606060', fontSize: '14px', textTransform: 'capitalize', padding: '6px 24px', border: '1px solid #E5E8EB', fontFamily: 'Manrope' }}>No plan</Button>
            <Button component="a"
              href="/PricingPlans" sx={{
                background: '#0076FE', borderRadius: '50px', color: '#fff', fontSize: '14px', textTransform: 'capitalize', padding: '6px 24px', fontFamily: 'Manrope', "&:hover": {
                  background: "#005ed6",
                },
              }}>Choose Plan</Button>
          </Box>
        </Box>

        {/* Payment Method Section */}
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Box>
            <Typography sx={{ fontSize: '16px', fontWeight: '600', color: '#1A1F36', fontFamily: 'Manrope' }}>Payment method</Typography>
            <Typography variant="span" sx={{ fontSize: '14px', fontWeight: '400', color: '#606060', fontFamily: 'Manrope' }}>Credit card on file</Typography>
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'end', alignItems: 'center', gap: 1 }}>
            <Button sx={{ background: '#fff', borderRadius: '50px', color: '#0076FE', fontSize: '14px', textTransform: 'capitalize', padding: '6px 24px', border: '1px solid #0076FE', fontFamily: 'Manrope' }} onClick={() => setOpenPreview(true)}>View card info</Button>
            <Button
              sx={{ background: '#0076FE', borderRadius: '50px', color: '#fff', fontSize: '14px', textTransform: 'capitalize', padding: '6px 24px', fontFamily: 'Manrope' }}
              onClick={() => setOpenForm(true)}
            >
              +Add Card
            </Button>

          </Box>
        </Box>
      </Box>

      {/* Billing History */}
      <BillingHistory />
      {/* Add Card Modal */}
      <AddCardDetailsModal open={openForm}
        onClose={() => setOpenForm(false)}
        onSave={handleSaveCard} />
      <CardPreviewModal
        open={openPreview}
        onClose={() => setOpenPreview(false)}
        cards={cards}
      />
    </>
  );
};

export default BillingInformation;
